import React from 'react';
import { Box, Checkbox, Typography } from '@ublend-npm/aulaui-core';
import { ExtensionGroup, ManageExtensionStyles } from './ManageExtension.types';

type Props = {
  groups: ExtensionGroup[];
  onToggleGroup: (groupId: string) => void;
  selectedGroupIds: string[];
  styles: ManageExtensionStyles;
};

const ExtensionGroupsStep = ({
  groups,
  onToggleGroup,
  selectedGroupIds,
  styles,
}: Props) => (
  <Box component="ul" sx={styles.groupList}>
    {groups.map((group) => {
      const isSelected = selectedGroupIds.includes(group.id);
      return (
        <Box component="li" key={group.id} sx={styles.groupRow}>
          <Checkbox
            checked={isSelected}
            label=""
            onChange={() => onToggleGroup(group.id)}
            inputProps={{ 'aria-label': `Assign group ${group.name}` }}
          />
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={styles.groupName}>{group.name}</Typography>
            <Typography sx={styles.groupCount}>
              {group.students.length}{' '}
              {group.students.length === 1 ? 'student' : 'students'}
            </Typography>
          </Box>
        </Box>
      );
    })}
    {!groups.length && (
      <Typography component="li" sx={styles.emptyGroups}>
        No groups are available in this space.
      </Typography>
    )}
  </Box>
);

export default ExtensionGroupsStep;
